import { FormActionType } from '../registro-personas-empresas-lib.model';

// Check item
export interface CheckItem {
  id: number; // Id del la entidad
  tipo_id: number; // Id del tipo
  nombre: string;
  selected: boolean;
}

export function createEmptyCheckItem(): CheckItem {
  return {
    id: null,
    tipo_id: null,
    nombre: null,
    selected: null
  };
}

export function createCheckItem(params: any): CheckItem {
  return {
    ...createEmptyCheckItem(),
    ...params
  };
}

// CheckListFormInput
export interface CheckListFormInput {
  action: FormActionType;
  elementosCheck: CheckItem[];
  addOther: boolean;
}

export function createEmptyCheckListFormInput(): CheckListFormInput {
  return {
    action: null,
    elementosCheck: [],
    addOther: null
  };
}

export function createCheckListFormInput(params: any): CheckListFormInput {
  return {
    ...createEmptyCheckListFormInput(),
    ...params
  };
}

export function crearCheckList(lista: any[]): CheckListFormInput {
  let salida = createEmptyCheckListFormInput();
  for (const elemento of lista) {
    salida.elementosCheck.push({
      id: elemento.id,
      nombre: elemento.nombre,
      tipo_id: elemento.tipo_id,
      selected: false
    });
  }
  return salida;
}

export interface CheckListForm {
  elementosCheck: [];
}
